import { gql } from '@apollo/client';

export const SEARCH_SUGGESTION_QUERY = gql`
  query SearchSuggestion($keyword: String) {
    suggestion(keyword: $keyword, per_page: 130) {
      items {
        type
        title
        subtitle
        image
        slug
        propertyType
        id
      }
    }
  }
`;

export interface SearchSuggestion {
  items: SearchSuggestionItem[];
}

export interface SearchSuggestionItem {
  type: string;
  title: string;
  subtitle: string;
  image: string;
  slug: string;
  propertyType: string;
  id: number;
}
